<template>
  <!--
    Badge de reCAPTCHA v3 — ACHIEVERY-1363.
    Deja de flotar sobre el contenido y queda anclado acá, al cierre de la home. Sigue siendo el
    badge nativo colapsado (logo + hover); lo que cambia es que lo recorta este contenedor en vez
    del borde de la ventana — ver `.recaptcha-badge` en app.scss.
    Con el badge a la vista no hace falta agregar el aviso legal de Google.
  -->
  <div v-if="enabled" class="recaptcha-badge">
    <div ref="host"></div>
  </div>
</template>

<script>
import { renderRecaptcha, hasRecaptchaKey } from '../helpers/recaptchaHelpers';

export default {
  name: 'RecaptchaBadge',
  props: {
    // Define el idioma del badge (parámetro `hl` de Google). Ver `recaptchaLang` en el helper.
    prismicLang: {
      type: String,
      required: true,
      validator: (value) => ['en-us', 'es-es'].includes(value)
    }
  },
  data() {
    return {
      enabled: hasRecaptchaKey()
    };
  },
  mounted() {
    if (!this.enabled) return;
    // Si falla, el form igual pide su token en el submit (el helper cae al badge flotante).
    renderRecaptcha(this.$refs.host, this.prismicLang).catch(() => { /* sin badge, pero el form anda */ });
  }
};
</script>
